
import { SanParsedGameData } from "../../../server/data/SanParsedGameData";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { RevealerManager } from "../../independent/revealer/RevealerManager";
import { SplashController } from "../../independent/splashScreen/SplashController";
import { PosterManager } from "../../independent/poster/PosterManager";
import { SanBackground } from "../../background/SanBackground";
import { SanEngineController } from "../../../engine/SanEngineController";
import { ReelOverlay } from "../../background/ReelOverlay";
import { AnimationEffects } from "../../../effects/AnimationEffects";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { Power3 } from "gsap";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SoundConfig } from "../../../SoundConfig";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SanGameModuleConfig} from "../../../SanGameModuleConfig";

class BonusIntroState extends StateHandler{
    public static readonly BONUS_HITS:string = "bonus_hits";
    public static readonly POSTING:string = "posting";

    public static readonly START_DELAY:string = "start_delay";

    public static readonly ENABLE_BUTTON:string = "enable_button";

    public static readonly BG_SWITCH:string = "bgSwitch";

    public static readonly JUMP_LOCK:string = "jump_lock";

    public static readonly DONE:string = "done";
}

export class BonusIntroPresentation extends Presentation {

    protected scatterPositions:number[];
    protected wildPositions:number[][];
    protected posOpened:boolean[];
    protected state:BonusIntroState = new BonusIntroState(PresentationState.INACTIVE);

    private fsLvl:number = 0;


    public setParsedGamedData(data:SanParsedGameData):void{
        this.scatterPositions = data.scatterReelPositions;
        this.wildPositions = data.wildReelPositions;

        this.posOpened = data.rawData.topRowOpened;

        this.state.set(BonusIntroState.START_DELAY);

        this.fsLvl = data.scatterAmount-3;

        SplashController.instance.setintroVal(data.scatterAmount - 2);

        SanGameModuleConfig.featurePrice.wasFeatureBuy = data.wasFeatureBuy;
    }

    public checkForActivation(data:SanParsedGameData):boolean{ return data.nextMode === "FREESPIN_SETUP"};

    preStart():void{
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.SKIP));
    }

    public getPresentation(){
        switch(this.state.state){
            case BonusIntroState.START_DELAY:
                this.pTimeline.to(this,0.45,{})
                this.state.set(BonusIntroState.ENABLE_BUTTON);
                break;
            case BonusIntroState.ENABLE_BUTTON:
                this.buttonScreen();
                break;
            case BonusIntroState.BONUS_HITS:
                // This will turn off Autoplay if in restricted jurisdiction
                if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
                    SlotGame.autoPlay.turnOffAutoplayOnBonus();
                }
                this.showBonuHits();
                break;
            case BonusIntroState.BG_SWITCH:
                this.changeBG();
                break;
            default:
                // this.pTimeline.to(this,0.3,{});
                this.PresentationState.set(PresentationState.INACTIVE);
                break;
        }
    }

    private buttonScreen():void{
        this.pTimeline.add([
            PosterManager.instance.setBlackScreenAlpha(0.7,0.4),
            SplashController.instance.play(0,() => this.clicked()),
            ReelOverlay.instance.changeAlpha(0, 0.4),
            SanBackground.instance.changeBgBlackness(0,0.4)
        ]);

        SanEngineManager.isFirstFS = true;
        this.state.set(BonusIntroState.ENABLE_BUTTON);
    }

    private changeBG():void{

        SanEngineManager.RAll((Reel:number) => { SanEngineManager.getReel(Reel).startReel(); })
        SoundManager.playSoundEffect(SoundConfig.instance.REELS_SPINNING,Number.MAX_SAFE_INTEGER);
        SanEngineManager.isPlaying = true;
        
        RevealerManager.getAllBars().forEach(r => {
            r.killGlow();
            r.setSpinMode(false);
            r.showRevSpinner(false);
        });
        
        RevealerManager.getAllBars().forEach(b => b.attentionDarkness(0.8, 1.5,true));

        const delay:number = 0.15;

        this.pTimeline.add(SanBackground.instance.moveBG(true),delay)
        this.pTimeline.add(SanBackground.instance.restoreOverlay(1),delay)
        this.pTimeline.add(() => SanBackground.instance.playCherring(),"-="+2);
        this.pTimeline.add(SplashController.instance.play(2),"-="+1.5);
        this.pTimeline.add(() => SanBackground.instance.playAtmosphere(this.fsLvl),"-="+1.5);
        // this.pTimeline.add(() => SanBackground.instance.fsSpineBG(this.fsLvl),"-="+1.5)
        

        this.pTimeline.add(
            AnimationEffects.Shake({
                obj:StageManager.stage,
                duration:this.pTimeline.duration()*0.75,
                hertz:120,
                x:0.6,
                y:0.8,
                Intensity:4,
                positionCb: () => new PIXI.Point(0,0),
                ease: Power3.easeOut,
                reverseEase:true
        }),delay);
        this.state.set(BonusIntroState.DONE);
    }

    private showBonuHits():void{

        let delay:number = 0.4;
        const nextAnim:number = 0.05;

        let openDelay:number = 0.75;
        if(this.posOpened.indexOf(false) >= 0)
            this.pTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.FS_JAIL_DOOR_CLOSE),openDelay) 
        for(let reel:number = 0; reel < SanEngineManager.AllReels.length;reel++){
            const rc:SanEngineController = SanEngineManager.getReel(reel);
            if(this.scatterPositions[reel] >= 0){
                this.pTimeline.add([
                    () => rc.getSymbol(this.scatterPositions[reel])!.changeState({ state: ReelSymbolStates.IDLE, type:0 }),
                ], delay);
            }else{
                this.pTimeline.add(rc.reelLocker(true), openDelay);
                rc.isActive = false;
            }
            for(let row:number = 0; row < rc.AllWindowSymbols.length;row++){
                const symPos:number = rc.AllWindowSymbols[row].posID;
                this.pTimeline.add(() => rc.getSymbol(symPos)!.attentionDarkness(1,0),delay);
                this.pTimeline.add(() => rc.getSymbol(symPos)!.attentionDarkness(0,0.5),delay+nextAnim);
            }
            this.pTimeline.add(() => rc.AllSymbols.forEach((s) => { if(!s.isScatter){
                s.changeState({state:ReelSymbolStates.NORMAL,duration:0,newSym:"X",forceState:true});
            }}),delay);
            
            delay += nextAnim;
        }
        SanEngineManager.RAll((Reel:number) => SanEngineManager.getReel(Reel).createStart());

        this.pTimeline.to(this,0.8,{});
        this.state.set(BonusIntroState.BG_SWITCH);
    }

    clicked():void{
        SoundManager.StartFSMusic();
        SplashController.instance.stop();
        PosterManager.instance.setBlackScreenAlpha(0)

        this.state.set(BonusIntroState.BONUS_HITS);
        this.pTimeline.totalProgress(1);
    }
}